import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import AdvertisementServices from "services/AdvertisementServices";
import { notifyError, notifySuccess } from "utils/toast";

const useAdvertisement = (id,tab) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
const [loading,setLoading] = useState(false);
  const [interiorUrl1, setInteriorUrl1] = useState('');
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);
      if ( !interiorUrl1) {
        notifyError("Advertisement Image required.");
        setIsSubmitting(false);
        return;  
      }
   
      const AdvertisementData = {
      
        title:data.title,
        url:data.url,
        content:data.content, 
        ad_image_1:interiorUrl1,
      };

     var res;
        if(tab === 0){
           res = await AdvertisementServices.updateAdvertisement( AdvertisementData);
        }else if (tab === 1){
           res = await AdvertisementServices.updateAdvertisementtwo( AdvertisementData);
        }
    
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
    
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
     // closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };
  const getAdvertisementData = async () => {

    try {
      var res;
      if(tab === 0){
         res = await AdvertisementServices.getAllAdvertisement();
      }else if(tab === 1){
         res = await AdvertisementServices.getAllAdvertisementtwo();
      }
   
      if (res) {
     

        setValue("title", res.data.title);
        setValue("url", res.data.url);
        setValue("content", res.data.content);
        setInteriorUrl1(res.data.ad_image_1);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("title");
      setValue("url");
      setValue("content");
      setInteriorUrl1('');
      clearErrors();
      return;
    }
      
    if (id) {
      getAdvertisementData();
    }
     // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    errors,loading,setLoading,
    isSubmitting,
   
    interiorUrl1, setInteriorUrl1
  };
};  

export default useAdvertisement;
